import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosRegular } from '../../style/theme';

type StyledFormInputProps = {
    value?: string;
    onInput: (value: any) => void;
    placeholder?: string;
    name?: string;
    hasErrors?: boolean;
    autoWidth?: boolean;
    width?: string;
    monospace?: boolean;
};

export const StyledTextInput = styled.input<StyledFormInputProps>`
    padding: 1rem;
    border-radius: 0.8rem;
    border: ${p => p.hasErrors ? `1px solid ${theme.colors.text.pink}` : '1px solid #707070'};
    font-size: ${theme.fontSize.normal};
    font-family: ${ p => p.monospace ? '\'Courier New\', Courier, \'Lucida Console\', monospace' : fontFamilyAtosRegular };
    font-weight: 400;
    color: ${theme.palette.darkGray};

    ${p => p.autoWidth 
        ? `
            width: auto;
            flex-grow: 1;
        ` : `
            width: 100%;
        `};

    ${p => p.width  ? `max-width: ${p.width};` : '' };
`;
